/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const patchItemStatusRequestSchema = z.object({
  afterId: z.int().nullish(),
  beforeId: z.int().nullish(),
  color: z.string().nullish(),
  default: z.boolean().nullish(),
  name: z.string().nullish(),
  schedulingType: z.enum(['IN_PROGRESS', 'TO_DO', 'DONE']).nullish(),
});
